import React from "react";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery } from 'react-responsive';
import Slider from "react-slick";
const brands = [
  { src: "/assets/images/kwikpass/foxtale.png", alt: "Foxtale" },
  { src: "/assets/images/kwikpass/levis.png", alt: "Levis" },
  { src: "/assets/images/kwikpass/plix.png", alt: "Plix" },
  { src: "/assets/images/kwikpass/libas.png", alt: "Libas" },
  { src: "/assets/images/kwikpass/rare-rabbit.png", alt: "Rare Rabbit" },
  { src: "/assets/images/kwikpass/aqualogica.png", alt: "Aqualogica" },
  { src: "/assets/images/kwikpass/caffeine.png", alt: "Caffeine" },
  { src: "/assets/images/kwikpass/adilqadri.png", alt: "Adilqadri" },
  { src: "/assets/images/kwikpass/bombay.png", alt: "Bombay" },
  { src: "/assets/images/kwikpass/blissclub.png", alt: "Blissclub" },
  { src: "/assets/images/kwikpass/mivi.png", alt: "Mivi" },
  { src: "/assets/images/kwikpass/arata.png", alt: "Arata" },
  { src: "/assets/images/kwikpass/Beco.png", alt: "Beco" },
  { src: "/assets/images/kwikpass/palm.png", alt: "Palm" },
  { src: "/assets/images/kwikpass/Ace.png", alt: "Ace" }
];




export const SectionOne = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const banners = [0, 1, 2]; // Representing your three banners


  // const [animate, setAnimate] = useState(false);
  // const [position, setPosition] = useState({ top: "50%", left: "45%" });

  // const [currentBanner, setCurrentBanner] = useState(2);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const fullImageSliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <div className="kwik-pass section-1">
        <div className="container-fluid">
          <div className="row banner align-items-center" style={{width:"100%",maxWidth:"100%",overflowX:"hidden",boxSizing:"border-box"}}>
            <div className="col-lg-6 col-md-12 banner-left">
              <div className="heading">
              
                  <div className="first mb-3">
                    <p>KWIKPASS</p>
                  </div>
                  <h1>
                  Turn Every Visitor into a Paying Customer
                  </h1>
                  <p className="mt-3 second">
                  Effortlessly and securely identify visitors with phone-first logins and smart pop-ups.
                  Convert anonymous browsers into loyal customers and drive revenue with the most secure 
                 Shopify customer identification platform.
                  </p>
             
                  <div className="btn">
                    <a href="../contact">
                      <button className="cta">Book a Demo</button>
                    </a>
                    <a href="https://apps.shopify.com/kwikpass">
                      <button className="cta2" style={{color:"#004B8D"}}>
                        {" "}
                        <img
                          src="/assets/images/kwikpass/shop.png"
                          alt="Shopify Logo"
                          width={20}
                        />
                        Get It On Shopify
                      </button>
                    </a>
                  </div>
                  <div className="mt-4" >
                      <a href="">
                        <img src="/assets/images/kwikpass/shopifybtn.png" alt="" />
                      </a>
                    </div>
          
              </div>
            </div>
            <div className="col-lg-6 col-md-12 banner-right mt-4 mt-lg-0">
              {isMobile ? (
    // ✅ MOBILE VIEW — only slider
              <div style={{ width: '100%', maxWidth: '100%', padding: '0 5px' }}>
              <Slider {...fullImageSliderSettings}>
                <div>
                  <img src="/assets/images/kwikpass/banner1.png" alt="Banner 1" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/banner2.png" alt="Banner 2" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/banner3.png" alt="Banner 3" className="slide-ban-image " />
                </div>
              </Slider>
            </div>
              ) : (
                // ✅ DESKTOP VIEW — animated image banners
                <div className="banner-container" style={{ position: "relative", height: "60vh", width: "auto" }}>
                  <AnimatePresence mode="wait">
                    {banners.map((banner, index) => (
                      currentIndex === index && (
                        <motion.div
                          key={index}
                          className="banner-bg"
                          initial={{ opacity: 1 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 1 }}
                          transition={{ duration: 0.5 }}
                        >
                          {/* BANNER 1 */}
                          {index === 0 && (
                               <>
                            {/* Banner 1 */}
                            <div
                              className="circle-bg"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "45%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <motion.img
                                src="/assets/images/kwikpass/banner1d.png"
                                alt="Banner Circle"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 1, delay: 0.1, ease: "easeOut" }}
                                className="banner-img"
                                style={{
                                  width: "clamp(80px, 10vw, 150px)",
                                  height: "auto",
                                }}
                              />
                            </div>
                              
                            <div className="banner-content" style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
                              <div className="side-images" style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
                                <motion.img
                                  src="/assets/images/kwikpass/banner1a.png"
                                  alt="Banner 1A"
                                  initial={{ opacity: 0, x: 100 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
                                  // className="banner-img"
                                  style={{
                                    width: "clamp(180px, 18vw, 250px)",
                                    height: "auto",
                                  }}
                                />
                                <motion.img
                                  src="/assets/images/kwikpass/banner1b.png"
                                  alt="Banner 1B"
                                  initial={{ opacity: 0, x: 100 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
                                  // className="banner-img"
                                  style={{
                                    width: "clamp(180px, 18vw, 250px)",
                                    height: "auto",
                                  }}
                                />
                              </div>
                                
                              <div className="side-images" style={{ display: "flex", justifyContent: "center" }}>
                                <motion.img
                                  src="/assets/images/kwikpass/banner1c.png"
                                  alt="Banner 1C"
                                  initial={{ opacity: 0, x: 100 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
                                  // className="banner-img"
                                  style={{
                                    width: "clamp(320px, 44vw, 60px)",
                                    height: "auto",
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}

                          {index === 1 && (
                            <>
                              {/* Banner 2 */}
                              <motion.div
                                className="circle-bg"
                                style={{
                                  position: "absolute",
                                  top: "40%",
                                  left: "58%",
                                  transform: "translate(-50%, -50%)",
                                }}
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 1, ease: "easeOut" }}
                              >
                                <motion.img
                                  src="/assets/images/kwikpass/banner1d.png"
                                  alt="Banner Circle 1"
                                  // className="banner-img"
                                  style={{ width: "clamp(80px, 10vw, 150px)", height: "auto" }}
                                />
                              </motion.div>

                              <div
                                className="banner-content2"
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "1rem",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <motion.img
                                  src="/assets/images/kwikpass/banner2a.png"
                                  alt="Banner 1A"
                                  initial={{ opacity: 0, x: 100 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
                                  className="banner-img img1"
                                  style={{ width: "clamp(100px, 10vw, 200px)", height: "auto" }}
                                />

                                <motion.img
                                  src="/assets/images/kwikpass/banner2b.png"
                                  alt="Banner 1B"
                                  initial={{ opacity: 0, x: 100 }}
                                  animate={{ opacity: 1, x: 0 }}
                                  transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
                                  className="img2"
                                  style={{ width: "clamp(160px, 15vw, 300px)", height: "auto" }}
                                />

                                <div
                                  className="side-images"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <motion.img
                                    src="/assets/images/kwikpass/banner2d.png"
                                    alt="Banner 1C"
                                    initial={{ opacity: 0, x: 100 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
                                    className="img3"
                                    style={{ width: "clamp(120px, 12vw, 210px)", height: "auto" }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
           

                            {index === 2 && (
                              <>
                                {/* Banner 3 */}
                                <motion.div
                                  className="circle-bg"
                                  style={{
                                    position: "absolute",
                                    top: "52%",
                                    left: "59%",
                                    transform: "translate(-50%, -50%)",
                                  }}
                                  initial={{ opacity: 0, scale: 0.8 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  transition={{ duration: 1, ease: "easeOut" }}
                                >
                                  <motion.img
                                    src="/assets/images/kwikpass/banner3c.png"
                                    alt="Banner Circle 1"
                                    className="banner-img"
                                    style={{ width: "clamp(90px, 10vw, 155px)", height: "auto" }}
                                  />
                                </motion.div>
                                
                                <div
                                  className="banner-content3"
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1rem",
                                  }}
                                >
                                  <motion.img
                                    src="/assets/images/kwikpass/banner3b.png"
                                    alt="Banner 1B"
                                    initial={{ opacity: 0, x: 100 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
                                    className=" img1a"
                                    style={{
                                      width: "clamp(250px, 32vw, 526px)",
                                      height: "auto",
                                      marginTop: "7vw", // ~100px on 1440px screen
                                    }}
                                  />

                                  <div
                                    className="side-images"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <motion.img
                                      src="/assets/images/kwikpass/banner3a.png"
                                      alt="Banner 1C"
                                      initial={{ opacity: 0, x: 100 }}
                                      animate={{ opacity: 1, x: 0 }}
                                      transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
                                      className="img3c"
                                      style={{ width: "clamp(100px, 11vw, 190px)", height: "auto" }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                        </motion.div>
                      )
                    ))}
                  </AnimatePresence>
                </div>
              )}
            </div>

          </div>
          <div className="banner-slider">
            <p className="slider-text">Trusted by 10,000+ Brands</p>
            <div className="slider-container">
              <div className="slider-track">
                {[...brands, ...brands].map((brand, index) => (
                  <img key={index} src={brand.src} alt={brand.alt} className="slider-img" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};